import { PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import KioskBasket from "./KioskBasket";
import KioskExit from "./KioskExit";
import KioskFlyItem from "./KioskFlyItem";
import KioskNav from "./KioskNav";

export interface KioskMenuProps extends PropsWithChildren {}

const KioskLayout = ({ children }: KioskMenuProps) => {
  const { id } = useParams<{ id: string; categoryId: string }>();

  return (
    <div className="grid h-screen grid-cols-[30rem_1fr] grid-rows-[minmax(0,_1fr)_14rem]" style={{ gridTemplateAreas: "\"sidebar content\" \"bottom bottom\"" }}>
     
      <KioskNav deliveryMethod={id} />
      <div className="kiosk-scroll-hidden min-h-0 overflow-y-auto overflow-x-hidden flex-[1_1_auto] pt-[5rem] px-[3rem]" style={{ gridArea: "content" }}>
        <KioskFlyItem />
        {children}
      </div>
      <KioskBasket />
    </div>
  );
};

export default KioskLayout;
